import React from 'react'
import { useState } from 'react'
import { FaRegUser } from 'react-icons/fa'
import { CiPower } from 'react-icons/ci'
import { useAuth } from '../../context/AuthContext'
import logsUserService from '../../services/LogsUserActionService'

function LogInInfo({ className }) {
  const [date, setDate] = useState(new Date())
  const { email, idUser, lastName, logout, name, token } = useAuth()

  const user = name + ' ' + lastName

  return (
    <div
      className={
        'bg-dark-dark-purple px-3 py-2 flex items-center gap-4 rounded-l-3xl flex-col lg:flex-row ' +
        className
      }
    >
      <FaRegUser className='text-white size-10 border border-white rounded-full p-2 overflow-visible hidden lg:block' />
      {name && lastName && (
        <div className='flex flex-col items-start '>
          <div>
            Bienvenido <span className='font-bold'>{user}</span>{' '}
          </div>
          <div className='hidden lg:block font-bold'>{dateToString(date)} </div>
        </div>
      )}
      <button
        className='bg-light-green text-white px-3 py-2 rounded-lg text-xs flex items-center gap-2 w-[100%] lg:w-auto 
            min-w-[min(100vw,13rem)] lg:min-w-min overflow-hidden mr-2'
        onClick={async () => {
          await logsUserService(idUser, `Cerrando sesión`, token);
          logout()
          window.location.reload()
        }}
      >
        Cerrar sesión <CiPower />
      </button>
    </div>
  )
}

export default LogInInfo

function dateToString(date) {
  const year = date.getFullYear()
  const month = date.getMonth() + 1
  const day = date.getDate()

  const dayOfWeekText = date.toLocaleString('es', {
    weekday: 'long',
  })

  const dayOfMonthText = date.toLocaleString('es', {
    day: 'numeric',
  })

  const monthText = date.toLocaleString('es', {
    month: 'long',
  })

  return `${dayOfWeekText}, ${dayOfMonthText} de ${monthText} de ${year}`
}
